import { z } from 'zod';
import { fobPointFormSchema } from './create-form.js';
export const createFobPointInputSchema = fobPointFormSchema.extend({
    makeDefault: z.boolean().optional(),
});
//# sourceMappingURL=create-input.js.map